import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatYouAchieve() {
  const achievements = ['Elaborar minidonas dulces y saladas', 'Crear torres temáticas para cumpleaños', 'Calcular costos y ganancias', 'Publicarlas y venderlas por redes', 'Tomar pedidos personalizados', 'Recuperar tu inversión con pocas ventas'];
  return <section className="w-full bg-[#F3ECE2] py-16 md:py-24" data-id="element-254">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-256">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2B1F] text-center mb-12" data-id="element-257">
            Lo que vas a lograr
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-258">
            {achievements.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-center gap-4 bg-white border border-[#E7DDD2] rounded-2xl p-6 shadow-sm hover:shadow-premium transition-shadow duration-300" data-id="element-259">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#F7F2EA] border border-[#E7DDD2] flex items-center justify-center" data-id="element-260">
                  <CheckIcon className="w-5 h-5 text-[#B66A2C]" data-id="element-261" />
                </div>
                <p className="text-[#3E2B1F] text-lg font-medium leading-snug" data-id="element-262">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}